module.exports = __webpack_public_path__ + "img/bank-generate-rules-disabled.5452e939.svg";